var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommodityManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.884 15.92H11.52a.638.638 0 010-1.274h2.727v-8.27L8.187 2.4l-5.913 3.97V9.01a.638.638 0 01-1.274 0V6.032c0-.213.106-.412.282-.53L7.83 1.108a.639.639 0 01.704-.004l6.7 4.394c.18.118.288.319.288.534v9.25a.638.638 0 01-.637.638z",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.954 12.002a.571.571 0 000-.434.657.657 0 00-.12-.189l-1.211-1.21a.574.574 0 00-.812.81l.24.235h-5.48a.571.571 0 000 1.143H8.43a.571.571 0 00.211-.046.571.571 0 00.314-.309h0zm-7.908 1.852a.571.571 0 000 .434c.029.07.07.133.12.189l1.211 1.211a.574.574 0 00.812-.811l-.24-.235h5.48a.571.571 0 000-1.143H1.57a.571.571 0 00-.211.046.571.571 0 00-.314.309h0z",
    strokeWidth: 0.2
  }))));
}

export default SvgCommodityManage;